export const appUpdateStoreNetworkCallback = {
	methods: {
		postRegionNC(response) {
			this.store_region_id = JSON.parse(response.data).id;
			this.postSubRegion(this.store_region_id);
		},
		postSubregionNC(response) {
			this.store_subregion_id = JSON.parse(response.data).id;
			console.log("postSubregionNC");
			this.updateStoreManualInfo(this.store_subregion_id);
		},
		postAddStoreInfo(response) {
			var store_outlet = JSON.parse(response.data).id;
			this.updateUsers(store_outlet);
		},
		getAllCountries(response) {
			console.log(JSON.parse(response));
		},
		getAllCountry(response) {
			if (response.status == 200) {
			}
		},
		postUpdateUserDetails(response) {
			if (response) {
				this.$notify.success({
					title: "Success",
					message: "success"
				});
				this.$router.push("/app-store-details").catch(()=>{});
			}
		},
		postEmailForDeleteUser(response) {
			console.log(response, "postEmailForDeleteUser");
		},
		getAllCity(response){
			this.all_city = JSON.parse(response.data).results;
		},
		deleteUserResponse(response){
			if(response.status == 200){
				// ********************removed selected delete user from table ****************************
				for(var i in this.add_user_row){
					for(var j in this.delete_user_list){
						if(this.add_user_row[i].email == this.delete_user_list[j]){
						this.add_user_row.splice(i,1);
						}
					}
				}
				this.delete_user_list = [];
				// ******************Updated static 3 rows in user table after deleted users******************
				if(this.add_user_row.length < 3){
					var temp = 3-this.add_user_row.length;
					for (var i = 0; i < temp; i++){
						this.add_user_row.push({
							first_name: "",
							last_name : "",
							email: "",
							designation: "",
							delete_user: false,
							disabled: false
						});
					}
				}
				this.show_delete_options = false;
				this.$notify.success({
					title: "Success",
					message: "User delete successfully!"
				});
			}
		}
	}
};
